var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHubsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.533,
    height: 19.157,
    viewBox: "0 0 15.533 19.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Hubs-act",
    d: "M231.713,211.588h-4.165a.447.447,0,0,1-.447-.447v-4.165a.447.447,0,0,1,.447-.447h4.165a.447.447,0,0,1,.447.447v1.638h2.431c-.012-1.714-.02-3.922-.022-6.153H232.16V204.1a.447.447,0,0,1-.447.447h-4.165a.447.447,0,0,1-.447-.447v-4.165a.447.447,0,0,1,.447-.447h4.165a.447.447,0,0,1,.447.447v1.635h2.408c0-2.25.01-4.461.022-6.153h-2.43v1.635a.449.449,0,0,1-.447.45h-4.165a.449.449,0,0,1-.447-.45V192.89a.447.447,0,0,1,.447-.447h4.165a.447.447,0,0,1,.447.447v1.635h2.883a.446.446,0,0,1,.442.45v6.6h2.09V199.94a.447.447,0,0,1,.447-.447h4.165a.447.447,0,0,1,.447.447v4.16a.447.447,0,0,1-.447.447h-4.165a.447.447,0,0,1-.447-.447v-1.635h-2.09v6.6a.447.447,0,0,1-.442.45H232.16v1.638a.447.447,0,0,1-.447.447Z",
    transform: "translate(-227.101 -192.443)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubsActive);
export default __webpack_public_path__ + "static/media/hubs_active.fd391ee3b4d81e41876a6f10415c0bd6.svg";
export { ForwardRef as ReactComponent };